import script from "./RegenerationStatusCell.vue?vue&type=script&setup=true&lang=js"
export * from "./RegenerationStatusCell.vue?vue&type=script&setup=true&lang=js"

import "./RegenerationStatusCell.vue?vue&type=style&index=0&id=6bbc8543&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bbc8543"]])

export default __exports__